/* eslint-disable */
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuOptions from '../MenuOptions';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { colors } from 'Constants/Colors';
import style from './style';

const { tableRowStyle, subtableRowStyle } = style;

export default function Row({
  row,
  limit,
  thereIsComponent,
  expandible,
  configButtonEvents,
  configButton,
  editButton,
  editButtonEvent,
  restartButton,
  restartButtonEvent,
  widthColumn,
  clickable,
  clickAction,
}) {
  const [open, setOpen] = useState(false);
  const widthCell = widthColumn === null ? {} : { width: widthColumn };

  return (
    <React.Fragment>
      <TableRow sx={tableRowStyle} onClick={clickable ? () => clickAction(row) : () => {}}>
        {expandible ? (
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        ) : null}

        {row.map((data, j) =>
          j < limit ? (
            <TableCell key={j} align="center" style={{ alignItems: 'center', ...widthCell }}>
              {thereIsComponent ? thereIsComponent(row, j) : data}
            </TableCell>
          ) : null
        )}

        <TableCell align="center">
          <Button onClick={editButton ? () => editButtonEvent(row) : undefined} disabled={!editButton}>
            <EditIcon
              style={{ color: editButton ? colors.GREEN : colors.GRAY }}
              visibility={editButton ? 'visible' : 'hidden'}
            />
          </Button>
        </TableCell>

        {restartButton ? (
          <TableCell align="center">
            <Button onClick={() => restartButtonEvent(row)}>
              <RestartAltIcon style={{ color: colors.GREEN }} />
            </Button>
          </TableCell>
        ) : null}

        {configButton.length ? (
          <TableCell align="center">
            <MenuOptions options={configButton} optionsEvents={configButtonEvents} data={row} />
          </TableCell>
        ) : null}
      </TableRow>
      <TableRow sx={subtableRowStyle}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={row.length + 1}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>{expandible ? expandible(row) : null}</Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
